import type { HTMLAttributes, ReactNode } from 'react';

export interface PageHeadingProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

export function PageHeading({
  eyebrow,
  title,
  description,
  actions,
  className,
  ...headingProps
}: PageHeadingProps) {
  const classes = ['ui-page-heading', className ?? ''].filter(Boolean).join(' ');

  return (
    <header {...headingProps} className={classes}>
      <div className="ui-page-heading__content">
        {eyebrow && <div className="ui-page-heading__eyebrow">{eyebrow}</div>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="ui-page-heading__actions">{actions}</div>}
    </header>
  );
}
